<template>
    <level-selector
      @selectItem="selectItemListener"
      :selectorData="shortNodeList"
      :title="title">
    </level-selector>
</template>
<script>
import LevelSelector from '@/components/utils/level-selector.vue';
import clone from '@/utils/clone';

export default {
  name: 'project-level-selector',
  components: {
    LevelSelector,
  },
  props: {
    levelType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      shortNodeList: [],
    };
  },
  created() {
    this.requestEquipmentTree();
  },
  computed: {
    title() {
      let levelTitle = '';
      switch (this.levelType) {
        case 'xm':
          levelTitle = '项目';
          break;
        case 'pds':
          levelTitle = '配电室';
          break;
        case 'byq':
          levelTitle = '变压器';
          break;
        case 'jx':
          levelTitle = '进线';
          break;
        case 'cx':
          levelTitle = '出线';
          break;
        case 'jcx':
          levelTitle = '进出线';
          break;
        default:
          break;
      }
      return levelTitle;
    },
    nodeList() {
      return this.$store.getters.projectList;
    },
  },
  watch: {
    levelType() {
      this.requestEquipmentTree();
    },
    nodeList() {
      this.shortNodeList = this.getLevelList(clone(this.nodeList));
    },
  },
  methods: {
    // 选择控件监听
    selectItemListener(item) {
      this.$emit('selectItem', item);
    },
    requestEquipmentTree() {
      if (this.nodeList !== null) {
        this.shortNodeList = this.getLevelList(clone(this.nodeList));
        return;
      }
      this.$store.dispatch('projects/projectList',
        { level: this.getRequestLevel() });
    },
    getRequestLevel() {
      let requestLevel = '';
      switch (this.levelType) {
        case 'pds':
          requestLevel = 1;
          break;
        case 'byq':
          requestLevel = 2;
          break;
        case 'jx':
        case 'cx':
        case 'jcx':
          requestLevel = 3;
          break;
        default:
          requestLevel = 0;
          break;
      }
      return requestLevel;
    },
    getLevelList(res) {
      if (!this.levelType) {
        return res;
      }
      const arr = [];
      for (let i = 0; i < res.length; i += 1) {
        const nodeInfo = res[i];
        if (this.nodeHasLevelType(nodeInfo)) {
          arr.push(nodeInfo);
        }
      }
      return arr;
    },
    // 判断nodeList是否包含 projectLevelSelector
    nodeHasLevelType(nodeInfo) {
      let hasLevelType = false;
      if (this.getLevelTypes().indexOf(nodeInfo.oType) >= 0) {
        // eslint-disable-next-line no-param-reassign
        nodeInfo.Children = null;
        hasLevelType = true;
      }
      if (nodeInfo.Children) {
        for (let i = 0; i < nodeInfo.Children.length; i += 1) {
          const childInfo = nodeInfo.Children[i];
          if (this.nodeHasLevelType(childInfo)) {
            hasLevelType = true;
          }
        }
      }
      return hasLevelType;
    },
    getLevelTypes() {
      const types = [];
      switch (this.levelType) {
        case 'jcx':
          types.push('jx');
          types.push('cx');
          break;
        default:
          types.push(this.levelType);
          break;
      }
      return types;
    },
  },
};
</script>
